import { TimelineLite, Expo } from 'gsap/TweenMax';
// import hades from '@/scripts/hades';
// import utils from '@/scripts/utils';

export default function menu(el) {
  const tl = new TimelineLite({
    paused: true,
  });

  const main = el.querySelector('.app__inner');
  const aside = [document.querySelector('aside.right .aside__wrapper'), document.querySelector('aside.left .aside__wrapper')];
  const nav = el.querySelector('.menu');
  const items = Array.from(nav.querySelectorAll('li'));

  tl
    .addLabel('start')
    .set(items, {
      autoAlpha: 0,
      yPercent: 50,
    })
    .to([main, ...aside], 0.5, {
      autoAlpha: 0,
      ease: Expo.easeOut,
    }, 'start')
    .staggerTo(items, 1, {
      autoAlpha: 1,
      yPercent: 0,
      ease: Expo.easeOut,
    }, 0.1, 'start+=0.5');

  return tl;
}
